import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';

import { Store } from '@ngrx/store';

import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { MenuItem, MenuItemExtended } from '../../../base/models/menu-items';
import { UserContext } from '../../../auth/models/auth';

import * as menus from '../../../base/actions/menus.actions'
import * as fromBase from '../../../base/reducers'

@Component({
  selector: 'app-mega-menu',
  templateUrl: './mega-menu.component.html',
  styleUrls: ['./mega-menu.component.scss']
})
export class MegaMenuComponent implements OnDestroy {
  @Input() menuItems: MenuItem[]
  @Input() user: UserContext
  @Input() salesRep: boolean
  @Input() languages: string[]

  @Output() onToggleNavBar = new EventEmitter<boolean>()
  @Output() onToggleMobileUserOptions = new EventEmitter<boolean>()
  @Output() onSelectCustomer = new EventEmitter()
  @Output() onItemClick = new EventEmitter<void>()

  private _topMenus: MenuItemExtended[] = []
  routerSubscription: Subscription

  constructor(private router: Router, private store: Store<fromBase.State>) {
    this.routerSubscription = this.router.events.pipe(
      filter(ev => ev instanceof NavigationStart)
    ).subscribe(() => {
      this.closeMegaMenu()
    })
   }

  get topMenus(): MenuItemExtended[] {
    if (this.menuItems && this.menuItems.length && this._topMenus.length === 0) {
      this._topMenus = this.menuItems
        .filter(menu => menu.parent === null)
        .map(menu => {
          const topMenu: MenuItemExtended = {
            ...menu,
            isActive: false
          }
          return topMenu
        })
    }
    return this._topMenus;
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe()
  }

  onTopMenuClick($event: MouseEvent, menu: MenuItemExtended) {
    if (menu.children && menu.children.length) {
      // Stop default event and propagation for top menu with children clicks. We only need the routerLink on top menus for the routerLinkActive directive to work.
      $event.stopPropagation()
      $event.preventDefault()

      // Close all other mega menus
      this.topMenus
        .filter(topMenu => topMenu.code !== menu.code)
        .map(topMenu => {
          topMenu.isActive = false
        })

      menu.isActive = !menu.isActive
      this.store.dispatch(new menus.ToggleMegaMenu(menu.isActive))

      return false
    }
  }

  hasChildMenus(menu: MenuItem): boolean {
    if (menu && menu.children && menu.children.length) {
      return true
    }
    return false
  }

  getChildMenu(childCode: string): MenuItem {
    if (this.menuItems && this.menuItems.length) {
      const childMenu = this.menuItems.find(menu => menu.code === childCode)

      return childMenu
    }
  }

  closeMegaMenu(): void {
    this.topMenus.forEach(menu => menu.isActive = false)
    this.store.dispatch(new menus.ToggleMegaMenu(false))
  }

  itemClick(): void {
    this.onItemClick.emit()
  }
}
